import request from '@/utils/request'

export function fetchDrawTimes(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/creator-draw/left-count',
    method: 'post',
    data: data
  })
}

export function fetchDraw(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/draw',
    method: 'post',
    params: data
  })
}

export function fetchAwardInfo(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/query-result',
    method: 'post',
    data
  })
}

export function fetchWithdrawBonus(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/my/withdrawable-bonus',
    method: 'get',
    params: data
  })
}

export function fetchRaffleInfo(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/quota/current',
    method: 'post',
    data
  })
}

export function fetchDonateStatus(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/donate/activate/state',
    method: 'post',
    data
  })
}

export function fetchTransfer(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/creator-draw/transfer-to-donate',
    method: 'post',
    data
  })
}

export function fetchRaffleList(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/quota-log/list',
    method: 'post',
    data
  })
}

export function fetchAwardList(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/user-award-list',
    method: 'post',
    data
  })
}

export function fetchBonusList(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/bonus/records/query',
    method: 'post',
    data
  })
}

export function recoverComptition(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/creator-draw/restore-participation',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/views/activity_230/api.js